var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14219",
    "data-name": "Group 14219",
    transform: "translate(-1463 -492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14074",
    "data-name": "Group 14074",
    transform: "translate(1466 495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13137",
    "data-name": "Path 13137",
    d: "M0,0H2V10H0Z",
    transform: "translate(4)",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2978",
    "data-name": "Rectangle 2978",
    width: 2,
    height: 10,
    transform: "translate(10 4) rotate(90)",
    fill: "#ababab"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.3524a3addbc784502df08b8fb9ae2f9c.svg";
export { ForwardRef as ReactComponent };